var ads = {};
ads.lastAdTime = 0;
ads.wait = 0 * 60 * 1000; // minutes
ads.showAdOnLoad = true;
var GameArterSdk;

ads.init = function () {
  if (window.GamearterInstance === undefined || Garter === undefined) {
    setTimeout(ads.init, 100);
    return;
  }
  GameArterSdk = new GamearterInstance(
    {
      projectId: 10302, // Insert your project id here
      projectVersion: 1, // Insert your project version here
      sdkMode: "B", // Use SDK in Basic mode
      sdkVersion: "2.0", // use SDK ver 2.0
    },
    function (err) {
      if (err) console.error(err);
    }
  );

  GameArterSdk.I.AddExternalCbListener(
    "SdkInitialized",
    function () {},
    function (err, res) {
      console.log(err, res);
    }
  );
};

ads.showAd = function () {
  if (GameArterSdk === undefined) return;

  ads.currentAdd = "midgame";
  GameArterSdk.I.CallAd("midroll", function (adState) {
    switch (adState) {
      case "loaded":
        // mute game
        break;
      case "completed":
        {
          ads.onVideoCompleted();
        }
        break;
      default:
      // all other ad statuses provided by ad provider (e.g. "started")
      // these statuses have informatic character only.
    }
  });
};

ads.showRewardedVideo = function (placement) {
  if (GameArterSdk === undefined) return;

  if (GameArterSdk.I.RewardedAdAvailability()) {
    ads.videoIsActive = true;
    ads.currentAdd = "rewarded";
    GameArterSdk.I.CallAd("rewarded", function (adState) {
      switch (adState) {
        case "loaded":
          // mute game
          break;
        case "completed":
          {
            ads.onVideoCompleted();
          }
          break;
        case "failed":
          {
            ads.onVideoError();
          }
          break;
        default:
        // all other ad statuses provided by ad provider (e.g. "started")
        // these statuses have informatic character only.
      }
    });
  } else {
    ads.onVideoNotAvailable();
  }
};

ads.preloadRewardedAd = function () {
  ads.preloaded = true;
  return;
  if (GameArterSdk === undefined) {
    setTimeout(ads.preloadRewardedAd, 1000);
    return;
  }
  GameArterSdk.preloadAd("rewarded")
    .then((response) => {
      ads.preloaded = true;
    })
    .catch((error) => {
      ads.preloaded = false;
    });
};

ads.onVideoStarted = function () {
  ads.videoIsActive = true;
};

ads.onVideoCompleted = function () {
  ads.videoIsActive = false;
  ads.lastAdTime = Date.now();
  if (ads.currentAdd === "rewarded") {
    gameLogic.rewardPlayer();
    ads.preloadRewardedAd();
  }
};

ads.onVideoError = function () {
  ads.videoIsActive = false;
  if (ads.currentAdd === "rewarded") {
    ads.preloaded = false;
    if (ads.adBlocker) {
      setTimeout(gameScreen.openWarning, 750, "adBlockerTitle", "adBlockerText");
    } else {
      setTimeout(gameScreen.openWarning, 750, "oopsTitle", "oopsText");
    }
  }
};

ads.onVideoNotAvailable = function () {
  console.log("NO ADS!");
  ads.videoIsActive = false;
  setTimeout(gameScreen.openWarning, 750, "noAdsTitle", "noAdsText");
};

//waiting time
ads.getWaitingTime = function () {
  return Math.max(0, ads.wait + ads.lastAdTime - Date.now());
};

ads.happyTime = function (power) {
  if (GameArterSdk == undefined) return;
  //
};

ads.gameplayStop = function () {
  if (GameArterSdk == undefined) return;
  //
  //
};

ads.gameplayStart = function () {
  if (GameArterSdk == undefined) return;
  //
};

ads.gameLoadingStart = function () {
  if (GameArterSdk == undefined) return;
  //
};

ads.gameLoadingFinished = function () {
  if (GameArterSdk === undefined) return;
  //
};

ads.gameLoadingProgress = function (progress) {
  if (GameArterSdk == undefined) return;
  //
};

ads.init();

//sitelock
